import { Card, Input, CardBody, Chip, Popover, Autocomplete, AutocompleteItem, PopoverContent, PopoverTrigger, Table, TableBody, TableCell, TableRow, TableColumn, TableHeader, Button, CardFooter, useSelect, Checkbox, SelectItem, Select, Spinner, ModalHeader, ModalBody, ModalContent, Modal, useDisclosure, Switch, ModalFooter } from "@nextui-org/react"
import { useEffect, useMemo, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, MasterGrid } from "../../components"
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { faCalendarAlt, faChartBar, faExclamationTriangle, faList12, faListCheck, faSearch } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"
import { isMobile } from "react-device-detect"
import ApexCharts from "react-apexcharts";
import { fontSize } from "@mui/system"
import { color } from "framer-motion"
import { Link } from "react-router-dom"
import { setDetailParams, setNewEntryMode } from "../../state/masterItemEntrySlice"
//import StackedFabricChart from "../sample/Test"
import { useModalToast } from "../../components/modalToast/ModalToastContext"


const ENUM_YARNCOST_BY = {
    PurchaseRate: "PUR",
    PurchaseRateWithGst: "PURWITHGST",
    YarnRate: "YRN"
}
const ENUM_PRODCOST_BY = {
    Production: "PROD",
    Sale: "SALE"
}
const GrayItemCostingDashboard = () => {
    const { show } = useModalToast()
    const { user } = useSelector((state) => state.auth)
    const { compCode, yearId, startDate, endDate, compName } = useSelector((state) => state.company)
    const [yarnCostBy, setYarnCostBy] = useState(ENUM_YARNCOST_BY.PurchaseRate)
    const [prodCostBy, setProdCostBy] = useState(ENUM_PRODCOST_BY.Sale)
    const [selectedUnit, setSelectedUnit] = useState("")
    const [itemCostFilData, setItemCostFilData] = useState([])
    const [searchText, setSearchText] = useState("")
    const disapatch = useDispatch()
    const {
        isOpen: isOpenReportModel,
        onOpen: onOpenReportModel,
        onOpenChange: onOpenReportModelChange,
    } = useDisclosure()
    //const [data, setData] = useState([])
    // if (isError) {
    //     return <ErrorCard />
    // }
    const columns = [
        { header: "Fabric Item", accessor: "fitem_desc", type: "text", filterable: true, sortable: true, width: "150px", textcolor: "text-blue-700 font-semibold uppercase", link: linksUrl.masterItemEntry.createMasterItemEntry, linkaccessor: "fitem_code", isSticky: true },
        { header: prodCostBy == ENUM_PRODCOST_BY.Production ? "Total PROD. Meter" : "Total Sale Meter", accessor: "prod_meter", type: "number", filterable: true, align: "right", sortable: true, },
        { header: "Total yarn KGS", accessor: "total_weight", type: "number", filterable: true, sortable: true, align: "right" },
        { header: "Yarn Rate/MTR", accessor: "yarn_rate_mtr", type: "num", filterable: true, sortable: true, align: "right" },
        { header: "Avg Fix Cost/MTR", accessor: "avg_fix_cost", type: "num", filterable: true, sortable: true, align: "right", },
        { header: "Total Cost", accessor: "avg_cost", type: "num", filterable: true, sortable: true, align: "right", textcolor: "text-amber-600 font-semibold" },
        { header: "Avg Sale Rate", accessor: "avg_sale", type: "num", filterable: true, sortable: true, align: "right", textcolor: "text-pink-600 font-semibold" },
        { header: "Diff", accessor: "avg_diff", type: "num", filterable: true, sortable: true, align: "right", textcolor: "text-blue-700 font-semibold" },
        { header: "Diff Value", accessor: "diff_value", type: "currency", filterable: true, sortable: true, align: "right", textcolor: "text-purple-700 font-semibold" },

    ]
    const [filterDate, setFilterDate] = useState({
        start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
    })
    const { isError, isPending, data: grayData = [], mutate: filterData } = usePost({
        url: apiRoute.mainDashboard.itemWiseCosting.getItemCostingData,
        queryKey: "Fetch main Dashboard data",
        // onSuccessTasks:(data)=>{
        //     setData(data)

        // }
    })

    const { isLoading, data: unitMaster = [] } = useFetchWithBody({
        url: apiRoute.report.invoice.getUnit,
        queryKey: "Fetch Unit data",
        inputData: {
            compcode: compCode.join(",")
        }
    })

    const { data: FCostItems = [], mutate: getFilCostItm } = usePost({
        url: apiRoute.mainDashboard.fetchFilterCostItems,
        queryKey: "Fetch DeActive data",

    })

    const { isPending: ispendindCost, mutate: funAddUpdate } = usePost({
        url: apiRoute.mainDashboard.addFilterItem,
        queryKey: "Add UPdate Filter CostItem ",
        onSuccessTasks: (data) => {
            show("Settings Updated")
            getFilCostItm({
                data: {}
            })
        }

    })

    useEffect(() => {
        getFilCostItm({
            data: {}
        })
    }, [])

    const data = useMemo(() => {
        if (!grayData?.length) return [];

        const inactiveCodes = new Set(
            itemCostFilData
                .filter((item) => item.deactive === 1)
                .map((item) =>
                    String(item.item_code).trim().toUpperCase()
                )
        );

        return grayData
            .filter(
                (item) =>
                    !inactiveCodes.has(
                        String(item.fitem_code).trim().toUpperCase()
                    )
            )
            .map((item) => ({
                ...item,
                isActive: 1,
            }));
    }, [grayData, itemCostFilData]);


    useEffect(() => {
        if (!grayData?.length) {
            setItemCostFilData([]);
            return;
        }

        const inactiveCodes = new Set(
            (FCostItems || [])
                .filter((item) => item.deactive === 1)
                .map((item) =>
                    String(item.item_code).trim().toUpperCase()
                )
        );

        const costData = grayData.map((item) => ({
            item_code: item.fitem_code,
            item_desc: item.fitem_desc,
            deactive: inactiveCodes.has(
                String(item.fitem_code).trim().toUpperCase()
            )
                ? 1
                : 0,
        }));

        setItemCostFilData(costData);
    }, [grayData, FCostItems]);
    // const { data,itemCostFilData } = useMemo(() => {
    //     if (!grayData?.length) {
    //         return {
    //             data: [],
    //             itemCostFilData: [],
    //         };
    //     }

    //     const inactiveCodes = new Set(
    //         (FCostItems || [])
    //             .filter((item) => item.deactive === 1)
    //             .map((item) =>
    //                 String(item.item_code).trim().toUpperCase()
    //             )
    //     );

    //     // All items for your cost-item table
    //     const itemCostFilData = grayData.map((item) => ({
    //         item_code: item?.fitem_code,
    //         item_desc: item?.fitem_desc,
    //         deactive: inactiveCodes.has(
    //             String(item.fitem_code).trim().toUpperCase()
    //         )
    //             ? 1
    //             : 0,
    //     }));

    //     // Only active items
    //     const data = grayData
    //         .filter(
    //             (item) =>
    //                 !inactiveCodes.has(
    //                     String(item.fitem_code).trim().toUpperCase()
    //                 )
    //         )
    //         .map((item) => ({
    //             ...item,
    //             isActive: 1,
    //         }));

    //     return data
    //     //  {
    //     //     data,
    //     //     itemCostFilData,
    //     // };
    // }, [grayData, FCostItems]);


    // const { isPending: isPendingQua, data: qualityData = [], mutate: filtrQualityData } = usePost({
    //     url: apiRoute.mainDashboard.itemWiseCosting.getItemCostingData,
    //     queryKey: "Fetch main Dashboard Quality data",
    // })
    const funLoadData = () => {
        let error = ""
        const start = dayjs(filterDate.end)
        const end = dayjs(filterDate.start)
        const months = start.diff(end, 'month');
        const t_year = dayjs(startDate).format('YYYY')
        const minDate = t_year - 2 + "-" + dayjs(startDate).format('MM') + "-" + dayjs(startDate).format('DD')

        if (!dayjs(filterDate.start).isValid || !dayjs(filterDate.end).isValid ||
            filterDate.start == "Invalid date" || filterDate.end == "Invalid Date" ||
            filterDate.start == null || filterDate.end == null) {
            toast.error("Inavlid Start / End Date ", {
                "position": "top-center"
            })

        }
        else {
            if (dayjs(filterDate.start).isValid && dayjs(filterDate.end).isValid) {
                if ((dayjs(filterDate.end).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD")) ||
                    (dayjs(filterDate.start).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD"))) {

                    error += `Start / End Date must not be less than ${dayjs(minDate).format("DD-MM-YYYY")},`

                }
            }
            if (dayjs(filterDate.end).isValid && dayjs(filterDate.start).isValid) {
                if ((dayjs(filterDate.end).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD")) ||
                    (dayjs(filterDate.start).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD"))) {

                    error += `Start / End Date must not be greater than ${dayjs(endDate).format("DD-MM-YYYY")},`

                }
            }
            if (months > 12) error += "Date period must not be greater than 1 year,"
            //const CostBy = prodCostBy && prodCostBy != "" && prodCostBy != null ? prodCostBy : ENUM_PRODCOST_BY.Production
            //const yarnCostBy = prodCostBy && prodCostBy != "" && prodCostBy != null ? prodCostBy : ENUM_PRODCOST_BY.Production
            if (error == "") {
                filterData({
                    data: {
                        compcode: compCode.join(","),
                        fromdate: filterDate.start,
                        todate: filterDate.end,
                        cost_by: prodCostBy,
                        yarn_costby: yarnCostBy,
                        lac_id: selectedUnit || '',
                        action: '',
                        db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
                    }
                })

                // filtrQualityData({
                //     data: {
                //         compcode: compCode.join(","),
                //         fromdate: filterDate.start,
                //         todate: filterDate.end,
                //         cost_by: prodCostBy,
                //         lac_id: selectedUnit || '',
                //         //action: 'MonthSummary',
                //         action:'',
                //         db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC'
                //     }
                // })
            }
            else {
                const messages = error.split(',');
                toast.error(
                    <div>
                        {messages.map((msg, idx) => msg != "" ? (

                            <div key={idx} className="p-1">
                                <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle} ></FontAwesomeIcon>
                                {msg.trim()}</div> // Trim to remove extra spaces
                        ) : "")}
                    </div>,
                    {
                        position: "top-center",
                        icon: false,
                        style: { whiteSpace: 'pre-line', width: '400px', fontSize: "0.8rem", color: "#da3333ff" }, // Optional here, mostly needed if using \n
                    }
                );
            }
        }
    }

    useEffect(() => {
        if (prodCostBy == "" || prodCostBy == null)
            setProdCostBy(ENUM_PRODCOST_BY.Production)
        if (yarnCostBy == "" || yarnCostBy == null)
            setYarnCostBy(ENUM_YARNCOST_BY.PurchaseRate)
        funLoadData()

    }, [prodCostBy, selectedUnit, yarnCostBy])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilterDate(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleBtnClick = (e) => {
        e.preventDefault();
        funLoadData()

    }
    const handleReset = () => {
        setFilterDate({
            start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
            end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
        })
        filterData({
            data: {
                compcode: compCode.join(","),
                fromdate: dayjs(startDate).format("YYYY-MM-DD"),
                todate: dayjs(endDate).format("YYYY-MM-DD"),
                cost_by: prodCostBy,
                lac_id: selectedUnit || '',
                action: '',
                db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
            }
        })
        // filtrQualityData({
        //     data: {
        //         compcode: compCode.join(","),
        //         fromdate: dayjs(startDate).format("YYYY-MM-DD"),
        //         todate: dayjs(endDate).format("YYYY-MM-DD"),
        //        // action: 'MonthSummary',
        //         action:'',
        //         cost_by: prodCostBy,
        //         lac_id: selectedUnit || '',
        //         action: '',
        //         db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
        //     }
        // })

    }

    const qualities = [...new Set(
        // qualityData.map(d => (d.fitem_desc || "(No Name)").toString().trim())
        data.map(d => (d.fitem_desc || "(No Name)").toString().trim())
    )];

    // Step 2: Aggregate totals per quality
    const totalPerQuality = useMemo(() => {

        return qualities.map(qty => {
            // const filtered = qualityData.filter(
            const filtered = data.filter(
                d =>
                    (d.fitem_desc || "(No Name)")
                        .toString()
                        .trim() === qty
            )

            const isYarnRate =
                yarnCostBy === ENUM_YARNCOST_BY.YarnRate

            return {

                fitem_desc: qty,

                total_cost: filtered.reduce(
                    (sum, d) =>
                        sum +
                        (
                            // isYarnRate
                            //     ? Number(d.avg_item_cost || 0)
                            Number(d.avg_cost || 0)
                        ),
                    0
                ),

                sale_value: filtered.reduce(
                    (sum, d) =>
                        sum + Number(d.avg_sale || 0),
                    0
                ),

                diff_value: filtered.reduce(
                    (sum, d) =>
                        sum +
                        (
                            // isYarnRate
                            //     ? Number(d.avg_item_diff || 0)
                            Number(d.avg_diff || 0)
                        ),
                    0
                )

            }

        })

    }, [qualities, data, yarnCostBy])

    // Step 3: Prepare series data for stacked bars
    const series = [
        {
            name: "Cost",
            data: totalPerQuality.map(
                d => d.total_cost
            )
        },

        {
            name: "Sale",
            data: totalPerQuality.map(
                d => d.sale_value
            )
        },

        {
            name: "Diff",
            data: totalPerQuality.map(
                d => d.diff_value
            )
        }
    ]

    // Step 4: ApexCharts options
    const allValues = series.flatMap(s => s.data);
    const minValue = Math.min(...allValues.filter(v => v > 0));

    const chartOptions = {
        chart: {
            type: "bar",
            stacked: true,
            toolbar: { show: true },
            height: 400
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "60%", // adjust width
                dataLabels: {
                    position: 'top'
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: qualities,
            title: { text: "FABRIC ITEM" },
            labels: {
                trim: false,
                hideOverlappingLabels: false,
                rotate: -45,
                style: {
                    fontSize: "10px",
                    colors: "#000"
                }
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    // width: "100%",
                    height: "500px"
                },
                legend: {
                    floating: false,
                    position: 'bottom',
                },
            },
        }],
        yaxis: {
            // min: minValue * 0.9,   // start just below smallest value
            forceNiceScale: true,
            tickAmount: 10,
            //logarithmic: true,
            title: { text: "AMOUNT" },
            labels: {
                formatter: val => val.toFixed(2)
            }
        },
        tooltip: {
            y: {
                formatter: val => val.toFixed(2)
            }
        },
        legend: {
            position: "top",
            fontSize: "14px"
        },
        series: series,
        colors: ['#f43f5e', '#84cc16', '#f97316',],
    };


    const safeDivide = (num, den, decimals = 2) => {
        const n = Number(num);
        const d = Number(den);

        if (!Number.isFinite(n) || !Number.isFinite(d) || d === 0) {
            return 0;
        }

        return Number((n / d).toFixed(decimals));
    };

    // const data = useMemo(() => {

    // if (!searchText) return costData;

    // const lowerSearch = searchText.toLowerCase();

    // return costData.filter(item =>
    //     Object.values(item).some(val =>
    //         val !== null &&
    //         val !== undefined &&
    //         val.toString().toLowerCase().includes(lowerSearch)
    //     )
    // );
    //     const updatedData = costData.map((ele) => ({
    //         ...ele,
    //         show_diff_value:
    //             yarnCostBy == ENUM_YARNCOST_BY.YarnRate
    //                 ? ele?.diff_item_value?.toFixed(2)
    //                 : ele?.diff_value?.toFixed(2),
    //         show_avg_diff:
    //             yarnCostBy == ENUM_YARNCOST_BY.YarnRate
    //                 ? ele?.avg_item_diff?.toFixed(2)
    //                 : ele?.avg_diff?.toFixed(2),
    //         show_avg_cost:
    //             yarnCostBy == ENUM_YARNCOST_BY.YarnRate
    //                 ? ele?.avg_item_cost?.toFixed(2)
    //                 : ele?.avg_cost?.toFixed(2),
    //         show_yarn_rate_mtr:
    //             yarnCostBy == ENUM_YARNCOST_BY.YarnRate
    //                 ? ele?.yarn_item_rate_mtr?.toFixed(2)
    //                 : ele?.yarn_rate_mtr?.toFixed(2)

    //     }));
    //     return updatedData || [];
    // }, [costData, yarnCostBy]);

    const handleItem = (itemcode) => {
        disapatch(setDetailParams({ MItem_Code: itemcode }))
        disapatch(setNewEntryMode(false))
        window.open(linksUrl.masterItemEntry.createMasterItemEntry, "_blank")
        //(linksUrl.masterItemEntry.createMasterItemEntry)
    }

    // const handleSwitchChange = (index, name, e) => {
    //     const { checked } = e.target
    //     console.log(String(checked), checked)
    //     const newData = [...itemCostFilData]
    //     const updatedData = { ...itemCostFilData[index], [name]: String(checked) }
    //     newData[index] = updatedData

    //     // setGridData(newData)

    // }
    const handleSwitchChange = (index, name, e) => {
        const { checked } = e.target;

        setItemCostFilData((prev) => {
            const newData = [...prev];

            newData[index] = {
                ...newData[index],
                [name]: checked ? 1 : 0,
            };

            return newData;
        });
    };

    const reportModel = () => {
        return (
            <div>
                <Modal
                    isOpen={isOpenReportModel}
                    onOpenChange={onOpenReportModelChange}
                    size="xl"
                    placement="center"
                >
                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalHeader className="flex flex-row gap-1 border-b-2 border-gray-700 pb-2">
                                    Fabric Item Display Settings

                                </ModalHeader>

                                <ModalBody className="px-4 py-2">
                                    <p className="text-sm text-gray-500">
                                        Manage which fabric items are displayed by activating or deactivating them.
                                    </p>
                                    <div className="w-full overflow-hidden rounded-xl border border-gray-200 bg-white">

                                        {/* Table */}
                                        <div className="max-h-[300px] overflow-y-auto overflow-x-auto">
                                            <table className="w-full text-left text-sm ">
                                                <thead className="sticky top-0 z-20 bg-gray-100 border-b-2 shadow-sm">

                                                    <tr className="uppercase">
                                                        <th className="whitespace-nowrap px-2 py-2 font-semibold text-gray-600">
                                                            #
                                                        </th>

                                                        <th className="whitespace-nowrap px-2 py-2  font-semibold text-gray-600">
                                                            Fabric Item
                                                        </th>

                                                        <th className="whitespace-nowrap px-2 py-2 text-center font-semibold text-gray-600">
                                                            Status
                                                        </th>
                                                    </tr>
                                                    <tr colspan={3} className="p-2 bg-sky-700 " ></tr>
                                                </thead>

                                                <tbody className="divide-y divide-gray-300 text-xs">
                                                    {itemCostFilData.map((item, index) => (
                                                        <tr
                                                            key={item.item_code}
                                                            className={`transition  ${item.deactive === 1 ? "bg-red-50 text-red-600 font-semibold" : "hover:bg-gray-50 text-gray-900"}`}
                                                        >
                                                            <td className="px-2 py-1 font-semibold ">
                                                                {index + 1}
                                                            </td>

                                                            <td className="px-2 py-1">
                                                                <div className="font-medium ">
                                                                    {item.item_desc}
                                                                </div>
                                                            </td>

                                                            <td className={`px-2 py-1 `}>
                                                                <div className="flex items-center justify-center">
                                                                    <Switch
                                                                        color="danger"
                                                                        size="sm"
                                                                        isSelected={
                                                                            item.deactive === 1
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleSwitchChange(
                                                                                index,
                                                                                "deactive",
                                                                                e
                                                                            )
                                                                        }
                                                                    />

                                                                    <span
                                                                        className={`ml-3 w-16 text-sm font-medium ${item.deactive === 1
                                                                            ? "text-red-600"
                                                                            : "text-green-600"
                                                                            }`}
                                                                    >
                                                                        {item.deactive === 1
                                                                            ? "Deactive"
                                                                            : "Active"}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Buttons */}
                                        <div className="flex items-center  justify-end gap-2 border-t border-gray-300 bg-gray-100 px-4 py-2">
                                            <Button
                                                size="sm"
                                                color="danger"
                                                className="uppercase"
                                                isLoading={ispendindCost}
                                                onPress={handleFilterCostItem}
                                            >
                                                Update
                                            </Button>

                                            <Button
                                                size="sm"
                                                color="primary"
                                                variant="bordered"
                                                className="  bg-white font-semibold uppercase"
                                                onPress={onOpenReportModelChange}
                                            >
                                                Close
                                            </Button>
                                        </div>
                                    </div>
                                </ModalBody>
                            </>
                        )}
                    </ModalContent>
                </Modal>
            </div>
        )
    }
    const handleActiveGrayItem = () => {
        onOpenReportModel()
    }
    const handleFilterCostItem = () => {
        const filData = itemCostFilData.filter((ele) => ele.deactive == 1)
        funAddUpdate({
            data: {
                item_list: filData
            }
        })
    }
    if (isError) {
        return <ErrorCard />
    }

    return (
        <div>
            <MainContainer pageName="Gray Item Costing" breadcrumbs={["Dashboard", "Gray Item Costing"]}>
                {reportModel()}
                <div className="flex justify-end mb-2 flex-wrap bg-gradient-to-br from-white to-sky-50 p-2 shadow  items-center gap-2">
                    <div className=" bg-d-50 flex flex-wrap sm:flex-nowrap md:flex-nowrap  gap-5 items-center" >
                        <Autocomplete
                            size="sm"
                            label={"Unit:"}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder={"--Select--"}
                            className="  border-0 border-amber-400 sm:w-60 md:w-60 w-full font-semibold text-sm "
                            classNames={{ "label": "font-semibold" }}
                            labelPlacement="outside"
                            isClearable={true}
                            variant="flat"
                            color="danger"
                            isVirtualized
                            defaultItems={
                                unitMaster || []
                            }
                            onSelectionChange={setSelectedUnit}
                            selectedKey={selectedUnit}
                        >
                            {(list) => (
                                <AutocompleteItem

                                    key={list.Party_Id}
                                >
                                    {list.Party_Name}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                        <Select
                            selectedKeys={[yarnCostBy]}
                            variant="bordered"
                            color="default"
                            size="sm"
                            label="Cal.Yarn Cost By : "
                            labelPlacement="outside"
                            color="warning"

                            onChange={(e) => setYarnCostBy(e.target.value)}
                            classNames={{ "label": "p-0 m-0" }}
                            className=" h-7 bg-white border-0 border-amber-400 sm:w-52 md:w-52 w-full border-0 text-sm font-semibold"
                        >

                            <SelectItem key={ENUM_YARNCOST_BY.PurchaseRate}>Purchase Rate</SelectItem>
                            <SelectItem key={ENUM_YARNCOST_BY.PurchaseRateWithGst}>Purchase Rate With GST</SelectItem>
                            <SelectItem key={ENUM_YARNCOST_BY.YarnRate}>Yarn Rate</SelectItem>
                        </Select>
                        <Select
                            selectedKeys={[prodCostBy]}
                            variant="bordered"
                            color="primary"

                            size="sm"
                            label="Cost By : "
                            labelPlacement="outside"
                            onChange={(e) => setProdCostBy(e.target.value)}
                            classNames={{ "label": "p-0 m-0" }}
                            className=" h-7 bg-white border-0 border-amber-400 sm:w-40 md:w-40 w-full border-0 text-sm font-semibold"
                        >
                            <SelectItem key={ENUM_PRODCOST_BY.Production}>Production</SelectItem>
                            <SelectItem key={ENUM_PRODCOST_BY.Sale}>Sale</SelectItem>
                        </Select>
                    </div>
                    <div className="flex gap-2">
                        <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > From : {dayjs(filterDate.start).format("DD-MMM-YYYY")}</Chip>
                        <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > To : {dayjs(filterDate.end).format("DD-MMM-YYYY")}</Chip>
                    </div>                    {/* date */}

                    <Popover placement="bottom" variant="bordered"
                        isDismissable={true}
                        shouldCloseOnBlur={false}
                        shouldBlockScroll={true}
                        shouldCloseOnScroll={false}
                        showArrow={true}>
                        <PopoverTrigger>
                            <Button size="sm"
                                className="bg-sky-200  text-md border-2 border-sky-300 text-sky-600 px-1" isIconOnly={true}   >
                                <FontAwesomeIcon className="text-xl" icon={faCalendarAlt}></FontAwesomeIcon>
                            </Button>
                            {/* <Button size="sm"
                                                className="bg-sky-600 h-7 text-white" variant="shadow" color="warning"  >Change Date</Button> */}
                        </PopoverTrigger>
                        <PopoverContent className="z-[1000]">
                            <div
                                onMouseDown={(e) => e.stopPropagation()}
                                onTouchStart={(e) => e.stopPropagation()}
                            >
                                <form onSubmit={handleBtnClick} >
                                    <div className={`${isMobile ? 'flex-wrap justify-center' : ''} flex gap-2 p-4`}>
                                        <div className={`flex  gap-2 `}>

                                            <div className="relative">
                                                <input
                                                    type="date"
                                                    name="start"
                                                    value={filterDate.start}
                                                    onChange={handleChange}
                                                    required
                                                    className="block w-full p-1 text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                                                />

                                            </div>
                                            <div className="relative">
                                                <input
                                                    type="date"
                                                    name="end"
                                                    value={filterDate.end}
                                                    onChange={handleChange}
                                                    required
                                                    className="block w-full p-1  text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                                                />

                                            </div>
                                        </div>
                                        <div className={`flex  gap-2 `}>
                                            <Button size="sm" variant="shadow" className="bg-blue-700 h-7 text-white" type="submit" >Apply</Button>
                                            <Button size="sm" color="danger" variant="shadow" className=" h-7 text-white" onPress={handleReset} >Reset</Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </PopoverContent>
                    </Popover>
                </div>
                <div className="shadow pb-5 flex flex-col item-center min-w-md">
                    {isPending && (
                        <div className=" flex gap-1 p-2 justify-center font-semibold border-0 b-red-500 text-pink-700 text-center ">
                            <h2 className=" px-2" >Proccessing....</h2>
                            <Spinner size="sm" label="" className="" variant="simple" color="danger" labelColor="danger" />
                        </div>
                    )}
                    {/* {costData && costData?.length &&
                        <Input type="text" size="sm"
                            radius="none" placeholder="Search ...."
                            startContent={<FontAwesomeIcon className="text-gray-700" icon={faSearch}></FontAwesomeIcon>}
                            variant="bordered" className="bg-white border-0  border-gray-300"
                            value={searchText} onChange={(e) => setSearchText(e.target.value)}  ></Input>} */}
                    <div>
                        {/* className={` h-96   ${data && data.length > 10 ? "overflow-scroll" : ""}`} */}

                        {data && data?.length > 0 ?
                            (
                                <div>
                                    <div className="text-left" >
                                        <button
                                            type="button"
                                            onClick={handleActiveGrayItem}
                                            className="
                                                inline-flex items-center gap-2
                                                rounded-md
                                                border border-red-200
                                                bg-red-50
                                                px-2 py-1
                                                text-xs uppercase font-medium text-red-700
                                                shadow-sm
                                                transition-all duration-200
                                                hover:border-red-300
                                                hover:bg-red-100
                                                hover:text-red-800
                                                hover:shadow
                                                focus:outline-none
                                                ring-2 ring-red-400 focus:ring-offset-1
                                                active:scale-[0.98]
                                            "
                                        >
                                            {/* <FontAwesomeIcon
                                                icon={faListCheck}
                                                className="text-red-600 text-red-100 font-semibold"
                                            /> */}

                                            <span>Manage Fabric Items</span>
                                        </button>
                                    </div>
                                    <MasterGrid
                                        columns={columns}
                                        data={data}
                                        className={""}
                                        showPaging={false}
                                        pageSize={20}
                                        expandableRow={false}
                                        virtualize={false}
                                        headClass={"bg-sky-700 border-1 text-white border-slate-300 font-semibold"}
                                        filterClass={"bg-white border-1 border-slate-300"}
                                        footerClass={"bg-sky-700 text-white"}
                                        style={{ border: "1px solid red" }}
                                        exportHeader={{
                                            companyName: compName.join(","),
                                            reportName: `Costing`,

                                        }}
                                        minusCheckCol="avg_diff"
                                        isExport={false}

                                    ></MasterGrid>
                                </div>
                            ) : (<div className="text-gray-400  p-7 text-center" >  No Data Found ...</div>)
                        }
                    </div>
                </div>
                <div className="shadow mt-5 ">
                    <div className=" font-semibold flex text-md p-5 text-rose-600 align-top items-center tracking-wider">
                        <FontAwesomeIcon icon={faChartBar} className=" mr-5 text-md border-0 border-sky-500 text-lime-500" />
                        <div> Quality Cost Summary</div>
                    </div>
                    <ApexCharts
                        options={chartOptions}
                        series={series}
                        type="bar"
                        height={550}
                    /></div>
            </MainContainer>
        </div>
    )
}
export default GrayItemCostingDashboard